document.addEventListener("DOMContentLoaded", () => {

  const elements = document.querySelectorAll(".reveal");

  const observer = new IntersectionObserver((entries) => {

    entries.forEach(entry => {

      if (entry.isIntersecting) {
        entry.target.classList.add("revealed");
        observer.unobserve(entry.target);
      }

    });

  }, {
    threshold: 0.15
  });

  elements.forEach(el => observer.observe(el));

});